module.exports = __webpack_public_path__ + "static/play-cogito-solitaire-1-391daef8b6b8ef098b27accbd79b4d67.mp4";